import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

interface I_Sources {
  page: string;
  source: string;
  text: string;
}

interface I_DbCreds {
  username: string;
  password: string;
  url: string;
}
interface i_chatMessage {
  message: string;
  type: string;
  sources?: I_Sources[];
  model?: string;
  chat_type?: string;
  org_cypher?: string;
  cypher?: string;
  db_creds?: I_DbCreds;
  image_model?: string;
  collection_chunks?: string[];
  collection_images?: string[];
  pii?: boolean;
}

interface i_conversation {
  chat_ids: string[];
  conv_name: string;
  id: string;
  time: string;
}

// Define a conversation for the slice state
interface conversationState {
  conversation_id: string;
  chats: i_chatMessage[];
  selected_indexes: string[];
  conversations: i_conversation[];
  url?: string;
  username?: string;
  password?: string;
}

// Define the initial state using that conversation
const initialState: conversationState = {
  conversation_id: "",
  chats: [],
  selected_indexes: [],
  conversations: [],
  url: "",
  username: "",
  password: "",
};

export const conversationSlice = createSlice({
  name: "conversation",
  // `createSlice` will infer the state conversation from the `initialState` argument
  initialState,
  reducers: {
    addconversation: (state, action) => {
      return {
        ...state,
        conversation_id: action.payload.conversation_id,
        chats: action.payload.chats,
      };
    },
    appendChat: (
      state,
      action: {
        payload: i_chatMessage;
      }
    ) => {
      return {
        ...state,
        chats: [...state.chats, action.payload],
      };
    },
    resetChat: (state) => {
      state = initialState;
    },
    updateIndexes: (state, action) => {
      state.selected_indexes = action.payload;
    },
    addCypher: (state, action) => {
      state.url = action.payload.url;
      state.username = action.payload.username;
      state.password = action.payload.password;
    },
    addConversations: (state, action) => {
      return {
        ...state,
        conversations: action.payload,
      };
    },
    clearActiveChat: (state) => {
      state.conversation_id = "";
      state.chats = [];
    },
  },
});

export const {
  addconversation,
  appendChat,
  resetChat,
  updateIndexes,
  addConversations,
  addCypher,
  clearActiveChat
} = conversationSlice.actions;

// Other code such as selectors can use the imported `RootState` conversation
export const getconversationid = (state: RootState) =>
  state.conversation.conversation_id;
export const getChats = (state: RootState) => state.conversation.chats;
export const getSelectedIndexes = (state: RootState) =>
  state.conversation.selected_indexes;

export const getConversations = (state: RootState) =>
  state.conversation.conversations;
export const getCypherDetails = (state: RootState) => state.conversation;

export default conversationSlice.reducer;
